import type { DefaultValues } from 'react-hook-form';
import { useEffect } from 'react';
import { queryString } from '@olivierpascal/helpers';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import type { IResetPasswordFormValues } from '~/components/forms/ResetPasswordForm';
import { ResetPasswordForm } from '~/components/forms/ResetPasswordForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';
import { useAuth } from '~/lib/auth';

export type IResetPasswordPageProps = {
  defaultValues?: DefaultValues<IResetPasswordFormValues>;
  nextUrl?: string;
};

export const ResetPasswordPage: React.FC<IResetPasswordPageProps> = (props) => {
  const { defaultValues, nextUrl } = props;
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const qs = queryString.build({ nextUrl });
  const cancelUrl = `^/login${qs ? `?${qs}` : ''}`;

  return (
    <>
      <Helmet>
        <title>Reset your password</title>
      </Helmet>

      <Heading
        title={t('ResetPasswordPage.reset-your-password')}
        previousUrl={cancelUrl}
      />
      <ResetPasswordForm
        mode={
          defaultValues?.email && defaultValues?.token
            ? 'change'
            : 'request-change'
        }
        defaultValues={defaultValues}
        onSuccess={() =>
          navigate(
            `^/login${nextUrl ? `?${queryString.build({ nextUrl })}` : ''}`,
          )
        }
        cancelUrl={cancelUrl}
      />
    </>
  );
};
